import script from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNav.vue?vue&type=style&index=0&id=2310ff0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2310ff0c"]])

export default __exports__